import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { StandardDetailBreadcrumb } from './StandardDetailBreadcrumb'
import type { StandardDetailBackSource } from '../standardDetailBackNavigation'

type StandardDetailPageHeaderProps = {
  backSource: StandardDetailBackSource
  backTo: string
  reference: string
  onDelete: () => void
}

export function StandardDetailPageHeader({
  backSource,
  backTo,
  reference,
  onDelete,
}: StandardDetailPageHeaderProps) {
  const { t } = useTranslation(['standardsLibrary', 'common'])

  return (
    <div className='space-y-4'>
      <StandardDetailBreadcrumb
        backSource={backSource}
        backTo={backTo}
        currentLabel={reference}
      />

      <div className='flex flex-wrap items-end justify-between gap-2'>
        <div className='min-w-0'>
          <h2 className='text-2xl font-bold tracking-tight'>{reference}</h2>
          <p className='text-muted-foreground'>
            {t('standardsLibrary:detail.pageDescription')}
          </p>
        </div>
        <Button variant='destructive' size='sm' onClick={onDelete}>
          {t('common:actions.delete')}
        </Button>
      </div>
    </div>
  )
}
